export default "__VITE_ASSET__184f2273__"